// extracted by mini-css-extract-plugin
export default {"toggle":"MapDataToggle_toggle__-rMWw"};